import { configureWs } from '@ontruck/ontruck-rt-client';
import { useEffect, useRef } from 'react';
import config from 'utils/constants/config';
import { useAuth } from 'hooks/useAuth/useAuth';

export default async function useWebsockets({ channel, event, eventHandler }) {
  const { accessToken, profile } = useAuth();
  const socket = useRef(null);

  useEffect(() => {
    async function connectToWs() {
      const newSocket = await configureWs(config.WS_URL, {
        token: accessToken,
        debug: false
      })([
        {
          channel: `${channel}:${profile.driver.uuid}`,
          callbacks: {
            [event]: eventHandler
          }
        }
      ]);

      socket.current = newSocket;
    }
    if (
      accessToken &&
      eventHandler &&
      channel &&
      event &&
      profile &&
      !socket.current
    ) {
      connectToWs();
    }

    return () => {
      if (socket.current) {
        socket.current.disconnect();
        socket.current = null;
      }
    };
  }, [accessToken, channel, event, profile, eventHandler]);
}
